import i18n from "src/i18n/i18n";
import * as Yup from "yup";

export default class User {
    id: string;
    name: string;
    email: string;
    email_verified_at: string;
    created_at: string;
    updated_at: string;
    active: number;
    role_id: number;
    role_name: string;
    permissions: string[];
    role: {
        id: string,
        name: string
    }

    static can(user: User, permission: string): boolean {
        if (user) {
            return user.permissions.includes(permission);
        } else {
            return false;
        }
    }

    static getRules(user: User) {
        return user ?
        Yup.object().shape({
            name: Yup.string()
              .max(191)
              .required(i18n.t("VALIDATION.REQUIRED")),
            email: Yup.string()
              .email(i18n.t("VALIDATION.EMAIL"))
              .max(255)
              .required(i18n.t("VALIDATION.REQUIRED")),
            role_id: Yup.number()
              .max(191)
              .required(i18n.t("VALIDATION.REQUIRED"))
        }) :
        Yup.object().shape({
            name: Yup.string()
              .max(191)
              .required(i18n.t("VALIDATION.REQUIRED")),
            email: Yup.string()
              .email(i18n.t("VALIDATION.EMAIL"))
              .max(255)
              .required(i18n.t("VALIDATION.REQUIRED")),
            role_id: Yup.number()
              .max(191)
              .required(i18n.t("VALIDATION.REQUIRED")),
            password: Yup.string()
              .max(255)
              .required(i18n.t("VALIDATION.REQUIRED")),
            password_confirmation: Yup.string()
              .max(255)
              .required(i18n.t("VALIDATION.REQUIRED"))
        })
    }

    static getInitValues(user: User) {
        return {
          name: user ? user.name : '',
          email: user ? user.email : '',
          role_id: user ? user.role_id : '',
          active: user ? user.active : 1,
          password: '',
          password_confirmation: '',
        }
    }
}

export { User }
